const config = {
  site: {
    domain: "theunicornclub.org",
    URL: "https://theunicornclub.org",
  },
};

export default config;
